import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-[#dc4a3d] to-[#c0392b] py-2.5 px-4 text-center shadow-md" data-id="element-402">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-403">
        <motion.span animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 1.5
      }} className="text-lg" data-id="element-404">
          🔥
        </motion.span>
        <span className="text-white font-bold text-sm md:text-base" data-id="element-405">
          PRECIO DE LANZAMIENTO – 80% DE DESCUENTO
        </span>
      </div>
    </div>;
}